import { render, staticRenderFns } from "./ECensoCardItens.vue?vue&type=template&id=94636f06&scoped=true"
import script from "./ECensoCardItens.vue?vue&type=script&lang=js"
export * from "./ECensoCardItens.vue?vue&type=script&lang=js"
import style0 from "./ECensoCardItens.vue?vue&type=style&index=0&id=94636f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94636f06",
  null
  
)

export default component.exports